let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("kaW56")).then(() => parcelRequire('bBhxF'));